import { render, staticRenderFns } from "./MediasSelector.vue?vue&type=template&id=02572528"
import script from "./MediasSelector.vue?vue&type=script&lang=js"
export * from "./MediasSelector.vue?vue&type=script&lang=js"
import style0 from "./MediasSelector.vue?vue&type=style&index=0&id=02572528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports